module.exports = __webpack_public_path__ + "img/EducationalCategories.d3f71c99.svg";